export interface ItemWorkAside_t {
  title: string;
  iconLink: string;
  href: string;
}

const itemsAside = new Map<string, ItemWorkAside_t[]>([
  ["", []],
  [
    "td",
    [
      {
        title: "Mes fiches techniques",
        href: "auth/datasheets",
        iconLink: "https://cdn-icons-png.flaticon.com/512/888/888034.png",
      },
      {
        title: "Mes réalisations",
        href: "auth/addReal",
        iconLink: "https://cdn-icons-png.flaticon.com/512/1689/1689073.png",
      },
      {
        title: "Mes travaux corrigés",
        href: "auth/realMarked",
        iconLink: "https://cdn-icons-png.flaticon.com/512/135/135436.png",
      },
    ],
  ],
  [
    "tp",
    [
      {
        title: "Mes fiches techniques",
        href: "auth/datasheets",
        iconLink: "https://cdn-icons-png.flaticon.com/512/888/888034.png",
      },
      {
        title: "Mon planning des Live",
        href: "auth/nextLives",
        iconLink:
          "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/icone-planning-des-lives.png",
      },
      {
        title: "Mes replay",
        href: "auth/replay?&type=pratique",
        iconLink: "https://cdn-icons-png.flaticon.com/512/4210/4210845.png",
      },
    ],
  ],
]);

export default itemsAside;
